import Message from "../../message";
import EventBus from "@/services/eventBus";

export default class MultiplayerBout extends Message
{
    handle()
    {
        EventBus.emit('multiplayer-bout', this.message);
    }
}